import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Section, SectionLine, Summary } from 'src/app/core/models/tax-return.interface';
import { TableResponsiveService } from 'src/app/core/services/table-responsive.service';
import { Subject, takeUntil } from 'rxjs';

const TOTAL_COLUMNS = 7;

@Component({
  selector: 'app-table-tax-return',
  templateUrl: './table-tax-return.component.html',
  styleUrl: './table-tax-return.component.scss',
})
export class TableTaxReturnComponent implements OnInit, OnDestroy {
  /** أقسام الإقرار (مبيعات، مشتريات، إلخ) مع بنود كل قسم */
  @Input() sections: Section[] = [];
  /** إجماليات الإقرار (تُعرض كصفوف في أسفل نفس الجدول) */
  @Input() summary: Summary | null = null;

  maxVisibleColumns = TOTAL_COLUMNS;
  openMoreIndex: number | null = null;
  private destroy$ = new Subject<void>();

  /** Total table columns (visible data columns + optional more column) */
  get totalTableColumns(): number {
    return this.maxVisibleColumns < TOTAL_COLUMNS ? this.maxVisibleColumns + 1 : TOTAL_COLUMNS;
  }

  constructor(private tableResponsiveService: TableResponsiveService) {}

  ngOnInit(): void {
    this.tableResponsiveService.maxVisibleColumns$
      .pipe(takeUntil(this.destroy$))
      .subscribe((n) => {
        this.maxVisibleColumns = n === Infinity ? TOTAL_COLUMNS : Math.min(n, TOTAL_COLUMNS);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMore(rowId: number): void {
    this.openMoreIndex = this.openMoreIndex === rowId ? null : rowId;
  }

  rowId(sectionIdx: number, lineIdx: number): number {
    return sectionIdx * 10000 + lineIdx;
  }

  /** تحديد ما إذا كان البند صف إجمالي (خلفية خضراء) - عادة عندما code يحتوي على -TAX */
  isSummaryRow(line: SectionLine): boolean {
    if (line?.isSummaryRow === true) return true;
    const code = (line?.code ?? '') as string;
    return code.includes('-TAX');
  }

  /** قيمة مبلغ الفواتير للعرض: إن وُجد invoiceTotal استخدمه وإلا totalTax حسب نوع البند */
  getInvoiceTotal(line: SectionLine): number {
    if (line?.invoiceTotal != null) return line.invoiceTotal;
    return (line?.totalTax ?? 0) as number;
  }

  /** قيمة مبلغ المرتجعات للعرض */
  getReturnTotal(line: SectionLine): number {
    return (line?.returnInvoiceTotal ?? line?.totalReturnTax ?? 0) as number;
  }

  /** قيمة مبلغ الضريبة للعرض */
  getTaxAmount(line: SectionLine): number {
    return (line?.totalTax ?? 0) as number;
  }

  /** قيمة ضريبة المرتجعات للعرض */
  getReturnTaxAmount(line: SectionLine): number {
    return (line?.totalReturnTax ?? 0) as number;
  }
}
